import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";
import { getFieldValuesByTableAndId } from "./keyvalue";

export const countryDropdown = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/country`,
    );

    const items = response.data || [];
    const ids = items
      .map((item) => item.couId ?? item.id ?? item.value)
      .filter((id) => id !== undefined && id !== null);

    let activeMap = {};
    if (ids.length > 0) {
      try {
        const activeStatuses = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_reg_country",
          primaryKey: "cou_id",
          fieldNames: "cou_active",
          ids: ids.join(","),
        });

        if (Array.isArray(activeStatuses)) {
          activeStatuses.forEach((res) => {
            if (res) {
              const keyId = res.pkId ?? res.pk_id ?? res.primaryKey ?? res.id;
              if (keyId !== undefined && keyId !== null) {
                const rawVal = res.field1 != null ? String(res.field1).trim().toLowerCase() : "";
                const isDeleted =
                  rawVal === "2" ||
                  rawVal === "0" ||
                  rawVal === "deleted" ||
                  rawVal === "inactive" ||
                  rawVal === "false";
                activeMap[String(keyId)] = isDeleted;
              }
            }
          });
        }
      } catch (err) {
        console.error("Error fetching country active statuses:", err);
      }
    }

    return items
      .filter((item) => {
        const itemId = String(item.couId ?? item.id ?? item.value);
        if (activeMap[itemId] === true) {
          return false;
        }

        const directActive = item.couActive ?? item.active ?? item.status;
        if (directActive !== undefined && directActive !== null) {
          const strVal = String(directActive).trim().toLowerCase();
          if (
            strVal === "2" ||
            strVal === "0" ||
            strVal === "deleted" ||
            strVal === "inactive" ||
            strVal === "false"
          ) {
            return false;
          }
        }
        if (item.isDeleted === true) return false;
        return true;
      })
      .map((item) => ({
        key: item.couId,
        text: item.couCountry,
        value: item.couId,
      }));
  } catch (e) {
    console.error(e);
  }
};

export const countryStartsWith = async (search) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/country/namestartswith`,
      search,
    );

    const items = response.data || [];
    const ids = items
      .map((item) => item.value ?? item.id ?? item.couId)
      .filter((id) => id !== undefined && id !== null);

    let activeMap = {};
    if (ids.length > 0) {
      try {
        const activeStatuses = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_reg_country",
          primaryKey: "cou_id",
          fieldNames: "cou_active",
          ids: ids.join(","),
        });

        if (Array.isArray(activeStatuses)) {
          activeStatuses.forEach((res) => {
            if (res) {
              const keyId = res.pkId ?? res.pk_id ?? res.primaryKey ?? res.id;
              if (keyId !== undefined && keyId !== null) {
                const rawVal = res.field1 != null ? String(res.field1).trim().toLowerCase() : "";
                const isDeleted =
                  rawVal === "2" ||
                  rawVal === "0" ||
                  rawVal === "deleted" ||
                  rawVal === "inactive" ||
                  rawVal === "false";
                activeMap[String(keyId)] = isDeleted;
              }
            }
          });
        }
      } catch (err) {
        console.error("Error fetching country active statuses:", err);
      }
    }

    const activeItems = items.filter((item) => {
      const itemId = String(item.value ?? item.id ?? item.couId);
      if (activeMap[itemId] === true) {
        return false;
      }

      const directActive = item.couActive ?? item.active ?? item.status;
      if (directActive !== undefined && directActive !== null) {
        const strVal = String(directActive).trim().toLowerCase();
        if (
          strVal === "2" ||
          strVal === "0" ||
          strVal === "deleted" ||
          strVal === "inactive" ||
          strVal === "false"
        ) {
          return false;
        }
      }
      if (item.isDeleted === true) return false;
      return true;
    });

    return activeItems.map((item) => ({
      key: item.id ?? item.value ?? item.couId,
      title: item.text ?? item.title ?? item.couCountry,
      value: item.value ?? item.id ?? item.couId,
    }));
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const countryName = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/country/name/${id}`,
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};

export const countryDetailsById = async (id) => {
  try{
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/country/by-id/${id}`
    );
    return response.data;
  }catch (error) {
    console.error(error);
  }
}


export const countryNameByRegion = async ({searchText, id}) => {
  try {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/country/namestartswithregion/${id}`,
        searchText, // Send the name directly as the POST body
        {
          headers: { "Content-Type": "application/json" }, // Ensure JSON content type
        }
    );

    const items = response.data || [];
    const ids = items
      .map((item) => item.value ?? item.id ?? item.couId)
      .filter((id) => id !== undefined && id !== null);

    let activeMap = {};
    if (ids.length > 0) {
      try {
        const activeStatuses = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_reg_country",
          primaryKey: "cou_id",
          fieldNames: "cou_active",
          ids: ids.join(","),
        });

        if (Array.isArray(activeStatuses)) {
          activeStatuses.forEach((res) => {
            if (res) {
              const keyId = res.pkId ?? res.pk_id ?? res.primaryKey ?? res.id;
              if (keyId !== undefined && keyId !== null) {
                const rawVal = res.field1 != null ? String(res.field1).trim().toLowerCase() : "";
                const isDeleted =
                  rawVal === "2" ||
                  rawVal === "0" ||
                  rawVal === "deleted" ||
                  rawVal === "inactive" ||
                  rawVal === "false";
                activeMap[String(keyId)] = isDeleted;
              }
            }
          });
        }
      } catch (err) {
        console.error("Error fetching country active statuses:", err);
      }
    }

    const activeItems = items.filter((item) => {
      const itemId = String(item.value ?? item.id ?? item.couId);
      if (activeMap[itemId] === true) {
        return false;
      }

      const directActive = item.couActive ?? item.active ?? item.status;
      if (directActive !== undefined && directActive !== null) {
        const strVal = String(directActive).trim().toLowerCase();
        if (
          strVal === "2" ||
          strVal === "0" ||
          strVal === "deleted" ||
          strVal === "inactive" ||
          strVal === "false"
        ) {
          return false;
        }
      }
      if (item.isDeleted === true) return false;
      return true;
    });

    return activeItems.map((item) => ({
      key: item.id ?? item.value ?? item.couId,
      title: item.text ?? item.title ?? item.couCountry,
      value: item.value ?? item.id ?? item.couId,
    }));
  } catch (error) {
    console.error("Error fetching countries by region:", error);
    return [];
  }
};



